export default __webpack_public_path__ + "static/media/maintenance.3713eb01.png";